import { render, staticRenderFns } from "./custom-table.vue?vue&type=template&id=52764db0"
import script from "./custom-table.vue?vue&type=script&lang=ts"
export * from "./custom-table.vue?vue&type=script&lang=ts"
import style0 from "./custom-table.vue?vue&type=style&index=0&id=52764db0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports